module.exports = __webpack_public_path__ + "img/1440.601fbd1d.jpg";